import axios from "axios"
import { saveAs } from "file-saver"

const apiUrl = "/api/"

function buildUrl(path) {
  return `${apiUrl}${path}`
}

function buildOptions(options = {}, signal = null) {
  if (!options.headers) {
    options.headers = {}
  }

  if (signal) options.signal = signal

  options.headers.Authorization = localStorage.getItem("token")
  return options
}

function blobToBase64(blob) {
  return new Promise((resolve, _) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result)
    reader.readAsDataURL(blob)
  })
}
export default {
  scheduleBringFriendMail(id) {
    let url = buildUrl("contract/mail/bring-a-friend/" + id)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  fetchPhysiotherapists() {
    let url = buildUrl("physiotherapists")
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  createPhysiotherapist(data) {
    let url = buildUrl("physiotherapists")
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  updatePhysiotherapist(id, data) {
    let url = buildUrl("physiotherapists/" + id)
    return axios.put(url, data, buildOptions()).then((res) => res.data)
  },
  deletePhysiotherapist(id) {
    let url = buildUrl("physiotherapists/" + id)
    return axios.delete(url, buildOptions()).then((res) => res.data)
  },
  fetchBlackFridayStats(activatedOnly) {
    // let url = buildUrl("black-friday/stats/" + activatedOnly)
    let url = "https://app.wellcomefit.ch/api/black-friday/stats/" + activatedOnly
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  fetchHomeMiniStats() {
    // let url = buildUrl("black-friday/stats/" + activatedOnly)
    //let url = "https://app.wellcomefit.ch/api/dashboard/contracts/mini-stats"
    let url = buildUrl("dashboard/contracts/mini-stats")
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  // Downloads
  downloadContractUpgradePDF(upgradeId) {
    let url = buildUrl("dashboard/c/print/" + upgradeId)

    axios
      .get(
        url, //your url
        {
          responseType: "blob",
          headers: {
            Authorization: localStorage.getItem("token"),
          }, // important
        },
      )
      .then((response) => {
        if (window.flutter_inappwebview) {
          var reader = new FileReader()
          reader.readAsDataURL(response.data)
          reader.onloadend = function () {
            var dataUrl = reader.result
            var base64 = dataUrl.split(",")[1]

            window.flutter_inappwebview.callHandler("blobToBase64Handler", base64.toString(), "pdf", "vertragUpgrade")
          }
        } else {
          saveAs(response.data, "vertragUpgrade")
        }
      })
  },

  //Stats
  fetchContractStats(data) {
    let url = buildUrl("contract/stats")
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },

  fetchMTTAcceptedContracts(params = {}) {
    const query = new URLSearchParams(params).toString()
    let url = buildUrl(`dashboard/contracts/mtt/accepted?${query}`)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  downloadQRInvoicePDF(userId, contractIndex, nachname = "wellcomefit") {
    let url = buildUrl(`contractmanagement/pdf/${userId}/${contractIndex}`)
    let fileName = `QR_Rechnung_${nachname}`

    return axios
      .get(url, {
        responseType: "blob",
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      })
      .then((response) => {
        if (window.flutter_inappwebview) {
          // --- Mobile App Logik (Flutter) ---
          var reader = new FileReader()
          reader.readAsDataURL(response.data)
          reader.onloadend = function () {
            var dataUrl = reader.result
            var base64 = dataUrl.split(",")[1]

            window.flutter_inappwebview.callHandler("blobToBase64Handler", base64.toString(), "pdf", fileName)
          }
        } else {
          // --- Web Logik (Browser via file-saver) ---
          saveAs(response.data, fileName)
        }
      })
  },
  toggleQRPaymentStatus(userId, contractIndex, status) {
    return axios.put(buildUrl("dashboard/contracts/qr-bills/status"), { userId, contractIndex, status }, buildOptions()).then((res) => res.data)
  },
  uploadBankFile(payload) {
    // payload ist jetzt einfach das Objekt: { xmlData: "dein...xml...string" }
    return axios.post(buildUrl("dashboard/contracts/qr-bills/upload-camt"), payload, buildOptions()).then((res) => res.data)
  },
  confirmBankPayments(contractsToUpdate) {
    return axios.post(buildUrl("dashboard/contracts/qr-bills/confirm-camt"), { contractsToUpdate }, buildOptions()).then((res) => res.data)
  },
  fetchQRContracts(params = {}) {
    const query = new URLSearchParams(params).toString()
    let url = buildUrl(`dashboard/contracts/qr-bills?${query}`)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },

  // Upgrades
  addCommentContractUpgrade(data) {
    let url = buildUrl("dashboard/c/upgrade/status/comment")
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  updateContractUpgradeStatus(data) {
    let url = buildUrl("dashboard/c/upgrade/status/update")
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  fetchUpgradeContracts(data) {
    let url = buildUrl("dashboard/c/upgrade/status")
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  createContractUpgrade(contractInfo) {
    //let url = buildUrl('dasupdateContractUpgradeStatusate')
    let url = buildUrl("dashboard/c/upgrade/create")
    return axios.post(url, contractInfo, buildOptions()).then((res) => res.data)
  },
  fetchRunningTACContract(customerId, local = true) {
    if (local) {
      let url = buildUrl("dashboard/c/upgrade/taccontract")
      return axios.post(url, { customerId }, buildOptions()).then((res) => res.data)
    } else {
      let url = "https://app.wellcomefit.ch/api/dashboard/c/upgrade/taccontract"
      return axios.post(url, { customerId }, buildOptions()).then((res) => res.data)
    }
  },
  fetchPackageUpgradePossibilitesTemp(customerId, local = true) {
    if (local) {
      let url = buildUrl("dashboard/c/upgrade/possibilities/temp/admin")
      return axios.post(url, { customerId }, buildOptions()).then((res) => res.data)
    } else {
      let url = "https://app.wellcomefit.ch/api/dashboard/c/upgrade/possibilities/temp"
      return axios.post(url, { customerId }, buildOptions()).then((res) => res.data)
    }
  },
  fetchPackageUpgradePossibilites(customerId, local = true) {
    if (local) {
      let url = buildUrl("dashboard/c/upgrade/possibilities")
      return axios.post(url, { customerId }, buildOptions()).then((res) => res.data)
    } else {
      let url = "https://app.wellcomefit.ch/api/dashboard/c/upgrade/possibilities"
      return axios.post(url, { customerId }, buildOptions()).then((res) => res.data)
    }
  },
  fetchPackageUpgradePossibilitesForOwnCustomer() {
    let url = "https://app.wellcomefit.ch/api/dashboard/c/upgrade/possibilities/for/own/user"
    return axios.post(url, { customerId }, buildOptions()).then((res) => res.data)
  },
  saveRoodyTACContractMap(data) {
    let url = buildUrl("dashboard/c/mapper")
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  fetchRoodyTACContractMap() {
    let url = buildUrl("dashboard/c/mapper")
    return axios.get(url, buildOptions()).then((res) => res.data)
  },

  // Company Discount

  uploadCompanyDiscountList(formData, filename) {
    let url = buildUrl("dashboard/contract/companydiscountlist/" + filename)
    return axios
      .post(
        url,
        formData,
        buildOptions({
          headers: {
            "Content-Type": formData.type,
          },
        }),
      )
      .then((res) => res.data)
  },

  fetchCompanyConfirmations() {
    let url = buildUrl("dashboard/company/confirmations/download")

    axios
      .get(
        url, //your url
        {
          responseType: "blob",
          headers: {
            Authorization: localStorage.getItem("token"),
          }, // important
        },
      )
      .then((response) => {
        if (window.flutter_inappwebview) {
          console.log("FLUTTER IOS DOWNLOAD PDF START")
          var reader = new FileReader()
          reader.readAsDataURL(response.data)
          reader.onloadend = function () {
            var dataUrl = reader.result
            var base64 = dataUrl.split(",")[1]

            window.flutter_inappwebview.callHandler("blobToBase64Handler", base64.toString(), "xlsx", "Firmenrabattliste")
          }
        } else {
          saveAs(response.data, "Firmenrabattliste")
        }
      })
  },
  // Contract Routes
  fetchRecentlyAcceptedContracts(params = {}) {
    // Wandelt das params Objekt in einen String um: ?startDate=...&studios=...
    const query = new URLSearchParams(params).toString()

    // URL direkt zusammenbauen
    let url = buildUrl(`dashboard/contracts/recently/accepted?${query}`)

    // buildOptions() ohne extra params aufrufen
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  fetchRecentlyAcceptedContractsOld(params) {
    // z.B. { startDate, endDate, studios }
    let url = buildUrl("dashboard/contracts/recently/accepted")

    // Füge die Parameter zur Anfrage hinzu
    const options = {
      ...buildOptions(),
      params: params,
    }

    return axios.get(url, options).then((res) => res.data)
  },

  fetchExternalPackages(memberships) {
    let url = buildUrl("dashboard/contract/external/packages")
    return axios.post(url, memberships, buildOptions()).then((res) => res.data)
  },
  updateContractEditMode(infos) {
    let url = buildUrl("dashboard/contract/editmode")
    return axios.post(url, infos, buildOptions()).then((res) => res.data)
  },
  changeContractPublishedStatus(contract) {
    let url = buildUrl("dashboard/contract/published")
    return axios.post(url, contract, buildOptions()).then((res) => res.data)
  },
  createContractSettings(contract) {
    let url = buildUrl("dashboard/settings/contract")
    return axios.post(url, { contract }, buildOptions()).then((res) => res.data)
  },
  fetchUserContract(info) {
    let url = buildUrl("dashboard/contract/user/fetch/" + info.userId)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },

  downloadImage(imgUrl) {
    let title = "bild"
    let url = imgUrl
    axios({
      url, //your url
      method: "GET",
      responseType: "blob", // important
    }).then((response) => {
      if (window.flutter_inappwebview) {
        console.log("FLUTTER IOS DOWNLOAD PDF START")
        var reader = new FileReader()
        reader.readAsDataURL(response.data)
        reader.onloadend = function () {
          var dataUrl = reader.result
          var base64 = dataUrl.split(",")[1]
          console.log(base64)
          window.flutter_inappwebview.callHandler("blobToBase64Handler", base64.toString(), "png", title.replaceAll(" ", "_").replaceAll(".", "_"))
        }
      } else {
        saveAs(response.data, title.replaceAll(" ", "_").replaceAll(".", "_"))
      }
    })
  },
  getIframeprintUserContract(userId, index, title = "Vertrag") {
    let url = buildUrl("dashboard/contract/print/" + userId + "/" + index)
    return axios
      .get(
        url, //your url
        {
          responseType: "blob",
          headers: {
            Authorization: localStorage.getItem("token"),
          }, // important
        },
      )
      .then((res) => res.data)
  },
  printUserContract(userId, index, title = "Vertrag") {
    let url = buildUrl("dashboard/contract/print/" + userId + "/" + index)

    axios
      .get(
        url, //your url
        {
          responseType: "blob",
          headers: {
            Authorization: localStorage.getItem("token"),
          }, // important
        },
      )
      .then((response) => {
        if (window.flutter_inappwebview) {
          console.log("FLUTTER IOS DOWNLOAD PDF START")
          var reader = new FileReader()
          reader.readAsDataURL(response.data)
          reader.onloadend = function () {
            var dataUrl = reader.result
            var base64 = dataUrl.split(",")[1]
            console.log(base64)
            window.flutter_inappwebview.callHandler("blobToBase64Handler", base64.toString(), "pdf", title.replaceAll(" ", "_").replaceAll(".", "_"))
          }
        } else {
          saveAs(response.data, title.replaceAll(" ", "_").replaceAll(".", "_"))
        }
      })
  },
  createTemporaryUserContract(contract) {
    let url = buildUrl("dashboard/contract/user/create/temporary")
    return axios.post(url, { contract }, buildOptions()).then((res) => res.data)
  },
  createUserContractSelf(contract) {
    let url = buildUrl("dashboard/contract/user/create/self")
    return axios.post(url, { contract }, buildOptions()).then((res) => res.data)
  },
  createUserContract(contract) {
    let url = buildUrl("dashboard/contract/user/create")
    return axios.post(url, { contract }, buildOptions()).then((res) => res.data)
  },
  updateUserContract(data) {
    let url = buildUrl("dashboard/contract/user/update")
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  declineContract(data) {
    let url = buildUrl("dashboard/contract/user/status/decline")
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  // FÜGEN SIE DIESE NEUE FUNKTION HINZU
  addCommentToContract(data) {
    let url = buildUrl("dashboard/contract/user/comment/add")
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },

  updateContractStatus(data) {
    let url = buildUrl("dashboard/contract/user/status/update")
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  deleteTemporaryContract(info) {
    let url = buildUrl("dashboard/contract/temporary/delete")
    return axios.post(url, info, buildOptions()).then((res) => res.data)
  },
  deleteContract(info) {
    let url = buildUrl("dashboard/contract/delete")
    return axios.post(url, info, buildOptions()).then((res) => res.data)
  },
  createContract(contract, internalTitle, eMails, promotions, enabledStudios, preConditionText, postConditionText, useStudioCity, badge) {
    let url = buildUrl("dashboard/contract/create")
    return axios
      .post(
        url,
        { contract, internalTitle, eMails, promotions, enabledStudios, preConditionText, postConditionText, useStudioCity, badge },
        buildOptions(),
      )
      .then((res) => res.data)
  },
  fetchContract(contractId) {
    let url = buildUrl("dashboard/contracts/" + contractId)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  fetchContractsByStatus(status, params = {}) {
    // Hier passiert die Magie: URLSearchParams kümmert sich um das Encoding
    const query = new URLSearchParams(params).toString()

    // Status und Query zusammenfügen
    let url = buildUrl(`dashboard/contracts/user/status/${status}?${query}`)
    // let url = `https://app.wellcomefit.ch/api/dashboard/contracts/user/status/${status}?${query}`

    // Einfaches GET ohne config.params
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  fetchContractsByStatusOld(status, params = {}) {
    // params kann enthalten: studios (Array), page, limit, search
    let url = buildUrl("dashboard/contracts/user/status/" + status)

    // Konvertiere params für axios
    const config = buildOptions()
    config.params = params

    return axios.get(url, config).then((res) => res.data)
  },

  fetchContractsPublic(id) {
    let url = buildUrl("dashboard/contractspublic/" + id)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  fetchContracts() {
    let url = buildUrl("dashboard/contracts")
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  saveContractSettings(data, fieldName) {
    let url = buildUrl("dashboard/settings/contract/" + fieldName)
    return axios.put(url, data, buildOptions()).then((res) => res.data)
  },
  fetchContractSettings() {
    let url = buildUrl("dashboard/settings/contract")
    return axios.get(url, buildOptions()).then((res) => res.data)
  },

  // Contract V2
  fetchContractV2Catalogs() {
    return axios.get(buildUrl("contract-v2/catalogs"), buildOptions()).then((res) => res.data)
  },
  importContractV2Legacy(force = false) {
    return axios.post(buildUrl("contract-v2/catalogs/import-legacy"), { force }, buildOptions()).then((res) => res.data)
  },
  resetContractV2LegacyImport(id) {
    return axios.delete(buildUrl(`contract-v2/catalogs/${id}/reset-import`), buildOptions()).then((res) => res.data)
  },
  fetchContractV2Catalog(id) {
    return axios.get(buildUrl(`contract-v2/catalogs/${id}`), buildOptions()).then((res) => res.data)
  },
  previewContractV2Catalog(id, studioId, channel = "internal") {
    return axios
      .get(buildUrl(`contract-v2/catalogs/${id}/preview/${studioId}?channel=${encodeURIComponent(channel)}`), buildOptions())
      .then((res) => res.data)
  },
  saveContractV2Catalog(id, data) {
    return axios.put(buildUrl(`contract-v2/catalogs/${id}`), data, buildOptions()).then((res) => res.data)
  },
  cloneContractV2Catalog(id, name = null) {
    return axios.post(buildUrl(`contract-v2/catalogs/${id}/clone`), { name }, buildOptions()).then((res) => res.data)
  },
  publishContractV2Catalog(id) {
    return axios.post(buildUrl(`contract-v2/catalogs/${id}/publish`), {}, buildOptions()).then((res) => res.data)
  },
  fetchContractV2Rollouts() {
    return axios.get(buildUrl("contract-v2/rollouts"), buildOptions()).then((res) => res.data)
  },
  saveContractV2Rollout(studioId, data) {
    return axios.put(buildUrl(`contract-v2/rollouts/${studioId}`), data, buildOptions()).then((res) => res.data)
  },
  fetchContractV2PublicRollout(studioKey) {
    return axios.get(buildUrl(`contract-v2/public/rollout/${studioKey}`), buildOptions()).then((res) => res.data)
  },
  fetchContractV2PublicCatalog(studioKey, channel = "public") {
    return axios
      .get(buildUrl(`contract-v2/public/catalog/${studioKey}?channel=${encodeURIComponent(channel)}`), buildOptions())
      .then((res) => res.data)
  },
  createContractV2PublicQuote(data) {
    return axios.post(buildUrl("contract-v2/public/quotes"), data, buildOptions()).then((res) => res.data)
  },
  createContractV2Quote(data) {
    return axios.post(buildUrl("contract-v2/quotes"), data, buildOptions()).then((res) => res.data)
  },
  createContractV2Self(data) {
    return axios.post(buildUrl("contract-v2/contracts/self"), data, buildOptions()).then((res) => res.data)
  },
  createContractV2(data) {
    return axios.post(buildUrl("contract-v2/contracts"), data, buildOptions()).then((res) => res.data)
  },
  createContractV2Temporary(data) {
    return axios.post(buildUrl("contract-v2/contracts/temporary"), data, buildOptions()).then((res) => res.data)
  },
  finalizeContractV2Temporary(id, data) {
    return axios.post(buildUrl(`contract-v2/contracts/${id}/finalize`), data, buildOptions()).then((res) => res.data)
  },
  fetchContractV2Contracts(params = {}) {
    const query = new URLSearchParams(params).toString()
    return axios.get(buildUrl(`contract-v2/contracts${query ? `?${query}` : ""}`), buildOptions()).then((res) => res.data)
  },
  fetchContractV2Self() {
    return axios.get(buildUrl("contract-v2/contracts/self"), buildOptions()).then((res) => res.data)
  },
  fetchContractV2Contract(id) {
    return axios.get(buildUrl(`contract-v2/contracts/${id}`), buildOptions()).then((res) => res.data)
  },
  fetchContractV2Stats() {
    return axios.get(buildUrl("contract-v2/contracts-stats"), buildOptions()).then((res) => res.data)
  },
  updateContractV2Details(id, data) {
    return axios.patch(buildUrl(`contract-v2/contracts/${id}/details`), data, buildOptions()).then((res) => res.data)
  },
  updateContractV2EditLock(id, active) {
    return axios.put(buildUrl(`contract-v2/contracts/${id}/edit-lock`), { active }, buildOptions()).then((res) => res.data)
  },
  updateContractV2Status(id, status) {
    return axios.patch(buildUrl(`contract-v2/contracts/${id}/status`), { status }, buildOptions()).then((res) => res.data)
  },
  addContractV2Comment(id, text, status = null, reason = null) {
    return axios.post(buildUrl(`contract-v2/contracts/${id}/comments`), { text, status, reason }, buildOptions()).then((res) => res.data)
  },
  fetchContractV2TacMappings(studioId = null) {
    const query = studioId ? `?studioId=${encodeURIComponent(studioId)}` : ""
    return axios.get(buildUrl(`contract-v2/tac/mappings${query}`), buildOptions()).then((res) => res.data)
  },
  saveContractV2TacMappings(studioId, mappings) {
    return axios.put(buildUrl(`contract-v2/tac/mappings/${studioId}`), { mappings }, buildOptions()).then((res) => res.data)
  },
  queueContractV2Tac(id) {
    return axios.post(buildUrl(`contract-v2/contracts/${id}/tac/queue`), {}, buildOptions()).then((res) => res.data)
  },
}
